import React from "react";

function Heading(props) {
  return (
    <div >
      <h1 className="display-3 heading" >Tic-Tac-Toe</h1>
    </div>
  );
}

export default Heading;